/***** Shopify Chat Fix (44x44 button + SVG 48px) *****/
(function(){
  if (window.innerWidth >= 768) return;

  const CHAT_HOST_SELECTOR = '#shopify-chat inbox-online-store-chat';
  const BUTTON_SELECTOR = 'button[data-spec="toggle-button"]';
  const SVG_SELECTOR = 'button[data-spec="toggle-button"] svg';

  const FIX_SIZE = '44px';
  const SVG_SIZE = '40px';

  function setImportant(el, prop, value){
    if(!el) return;
    el.style.setProperty(prop, value, 'important');
  }

  function applyChatButtonStyle(btn){
    if(!btn) return;
    setImportant(btn, 'width', FIX_SIZE);
    setImportant(btn, 'height', FIX_SIZE);
    setImportant(btn, 'min-width', FIX_SIZE);
    setImportant(btn, 'min-height', FIX_SIZE);
    setImportant(btn, 'border-radius', '50%');
    setImportant(btn, 'display', 'flex');
    setImportant(btn, 'justify-content', 'center');
    setImportant(btn, 'align-items', 'center');
    setImportant(btn, 'margin', '0');
  }

  // ⭐ 新增：SVG 48px
  function applySvgStyle(shadow){
    if(!shadow) return;

    const svg = shadow.querySelector(SVG_SELECTOR);
    if(!svg) return;

    setImportant(svg, 'width', SVG_SIZE);
    setImportant(svg, 'height', SVG_SIZE);
  }

    // ⭐ 新增：SVG 48px
  function applyChatStyle(chatStyle){

  }

  // 主函数：找到 chat button 并套样式
  function patchChat(){
    const chat = document.querySelector(CHAT_HOST_SELECTOR);
    if(!chat) return;

    const shadow = chat.shadowRoot || chat;

    const btn = shadow.querySelector(BUTTON_SELECTOR);
    applyChatButtonStyle(btn);

    // ⭐ 加入 SVG 处理
    applySvgStyle(shadow);
    
  }

  // 点击时补一次（展开/关闭导致按钮变化）
  document.addEventListener('click', () => {
    setTimeout(patchChat, 40);
  }, { capture: true });

  // Mutation Observer —— 监听 Chat 元素结构变化
  const mo = new MutationObserver(() => {
    setTimeout(patchChat, 20);
  });

  const chatRoot = document.querySelector('#shopify-chat');
  if(chatRoot){
    mo.observe(chatRoot, { childList: true, subtree: true });
  }

  // 短轮询保证初次加载成功
  const start = Date.now();
  const poll = setInterval(() => {
    patchChat();
    if(Date.now() - start > 4000){
      clearInterval(poll);
    }
  }, 120);

  // 初次尝试
  patchChat();
})();
